var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3223 31.2175C26.7193 30.1967 29.6765 28.2246 31.7724 25.582C33.8683 22.9394 34.9962 19.7612 34.9953 16.5C34.9962 13.2388 33.8683 10.0606 31.7724 7.41801C29.6765 4.77542 26.7193 2.80329 23.3223 1.78255M23.3223 31.2175C19.8691 32.2609 16.1389 32.2609 12.6858 31.2175C9.28634 30.1987 6.32645 28.2274 4.22808 25.5847C2.12972 22.9419 1 19.7626 1 16.5C1 13.2374 2.12972 10.0581 4.22808 7.41533C6.32645 4.77257 9.28634 2.80129 12.6858 1.78255C16.1389 0.739151 19.8691 0.739151 23.3223 1.78255M23.3223 31.2175C26.7217 30.1987 29.6816 28.2274 31.78 25.5847C33.8783 22.9419 35.0081 19.7626 35.0081 16.5C35.0081 13.2374 33.8783 10.0581 31.78 7.41533C29.6816 4.77257 26.7217 2.80129 23.3223 1.78255",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0039 1.78259V31.2175",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07373 6.43011C6.65716 7.15957 8.31268 7.7509 10.0182 8.1962C12.6116 8.89231 15.3007 9.24705 18.0041 9.24966C20.6331 9.2484 23.2492 8.91473 25.7776 8.25817C27.5366 7.79453 29.2433 7.17984 30.875 6.42236M5.35409 26.8409C6.91407 26.1421 8.54063 25.5743 10.2136 25.1445C17.0105 23.4093 24.2706 24.0216 30.6031 26.8641",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8623 16.5H34.1458",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6682 1.78259L22.8041 1.99948C25.6187 6.37575 27.1024 11.3572 27.1024 16.4303C27.1024 21.5035 25.6187 26.4849 22.8041 30.8612M13.1191 1.78259L12.9832 1.99948C10.1716 6.37812 8.69324 11.3618 8.70071 16.4356C8.70818 21.5094 10.2012 26.4894 13.0256 30.8612",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.112216bdad3d2f1a94a2648892534543.svg";
export { ForwardRef as ReactComponent };